<template>
    <div class="wiki-model-mask">
        <div class="model-wrapper">
            <div class="model-header">
                <span class="title">{{data.title}}</span>
                <a class="close-btn" @click="cancel"></a>
            </div>
            <div class="model-body"><Form :items="items" :formData="data.formData" :labelWidth="data.labelWidth" :rules="data.rules" @close="cancel" @submit="confirm" /></div>
        </div>
    </div>
</template>

<script>
import Form from "@/views/zhiji/components/form/Form";

export default {
    name: "AddVideoTipModal",
    props: ["data"],
    components: {
        Form
    },
    data() {
        return {
            items: [
                {
                    name: "sectionTitle",
                    label: this.$t("zhiji.wiki.sectionTitle"),
                    type: "el-input",
                    extendProps: {
                        placeholder: this.$t("zhiji.wiki.placeholder.sectionTitle")
                    }
                },
                {
                    name: "sort",
                    label: this.$t("zhiji.wiki.sort"),
                    type: "el-input",
                    extendProps: {
                        placeholder: this.$t("zhiji.wiki.placeholder.sort")
                    }
                }
            ]
        };
    },
    methods: {
        confirm(data) {
            if (!data.sectionTitle) {
                this.$message.error(this.$t("zhiji.wiki.error.blockTitle"));
            } else if (!data.sort) {
                this.$message.error(this.$t("zhiji.wiki.error.sort"));
            } else {
                this.confirmHandler(data);
            }
        },
        confirmHandler(data) {
            let requestType = "addSection";
            if (this.data.id != "") {
                requestType = "updateSection";
            }
            this.zhiji
                .requestByServiceName(requestType, {
                    ...data,
                    sectionType: "list",
                    id: this.data.id,
                    lang: this.data.lang
                })
                .then(() => {
                    this.cancel();
                    this.data.confirm && this.data.confirm.call();
                });
        },
        cancel() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="scss" scoped>
.wiki-model-mask{
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    .title{
        font-size: 16px;
        line-height: 24px;
        color: #41475E;
    }
    .close-btn{
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        width: 44px;
        height: 40px;
        background: url(/zhiji/images/i-close.png) center center no-repeat;
    }
    .model-wrapper{
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 5px 8px rgba(90, 98, 111, 0.25);
        max-height: 85%;
        width: 640px;
        margin: 0 !important;
    }
    .model-header{
        position: relative;
        padding: 8px 20px 8px;
        background: #e4f1f9;
        border-radius: 8px 8px 0 0;
        min-height: 40px;
        box-sizing: border-box;
    }
    .model-body{
        flex: 1;
        overflow-y: auto;
        padding: 16px 24px 0;
        font-size: 12px;
        color: #41475E;
        word-break: break-all;
    }
    /deep/.el-input__inner{
        border-radius: 4px;
        border: 1px solid #d8e4f0;
        box-sizing: border-box;
        color: #41475E;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        outline: 0;
        width: 100%;
        background: #fff;
        font-size: 12px;
    }
    /deep/.el-form-item{
        margin-bottom: 20px;
    }
}

</style>
